import { EventsStreamTransformer } from './lib/event-stream.js';
import dedent from 'dedent';
export class OramaInterface {
    constructor(config) {
        Object.defineProperty(this, "baseURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "masterAPIKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "writeAPIKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "readAPIKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.baseURL = config.baseURL;
        this.masterAPIKey = config.masterAPIKey;
        this.writeAPIKey = config.writeAPIKey;
        this.readAPIKey = config.readAPIKey;
    }
    async request(config) {
        const remoteURL = new URL(config.url, this.baseURL);
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const requestObject = {
            method: config.method,
            headers,
        };
        if (config.body && config.method !== 'GET') {
            requestObject.body = JSON.stringify(config.body);
        }
        if (config.body && config.method === 'GET') {
            remoteURL.search = new URLSearchParams(config.body).toString();
        }
        const APIKey = this.getAPIKey(config.securityLevel);
        switch (true) {
            case config.method !== 'GET' && config.securityLevel !== 'read-query':
                headers.append('Authorization', `Bearer ${APIKey}`);
                break;
            case config.method === 'GET' && config.securityLevel === 'master':
                headers.append('Authorization', `Bearer ${APIKey}`);
                break;
            case config.method === 'GET' || config.securityLevel === 'read-query':
                remoteURL.searchParams.append('api-key', APIKey);
                break;
        }
        const request = await fetch(remoteURL.toString(), requestObject);
        if (!request.ok) {
            throw new Error(dedent(`
                Request to "${config.url}" failed with status ${request.status}:
                ${await request.text()}
            `));
        }
        return request.json();
    }
    async requestStream(config) {
        const remoteURL = new URL(config.url, this.baseURL);
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const APIKey = this.getAPIKey(config.securityLevel);
        remoteURL.searchParams.append('api-key', APIKey);
        const response = await fetch(remoteURL.toString(), {
            body: JSON.stringify(config.body),
            headers,
            method: config.method,
        });
        if (!response.ok) {
            throw new Error(dedent(`
                Request to "${config.url}" failed with status ${response.status}:
                ${await response.text()}
            `));
        }
        if (response.body === null) {
            throw new Error(`Response body is null for "${config.url}"`);
        }
        return response.body?.pipeThrough(new EventsStreamTransformer());
    }
    getAPIKey(securityLevel) {
        switch (securityLevel) {
            case 'master':
                if (!this.masterAPIKey) {
                    throw new Error('Master API key is required for this operation');
                }
                return this.masterAPIKey;
            case 'write':
                if (!this.writeAPIKey) {
                    throw new Error('Write API key is required for this operation');
                }
                return this.writeAPIKey;
            case 'read':
            case 'read-query':
                if (!this.readAPIKey) {
                    throw new Error('Read API key is required for this operation');
                }
                return this.readAPIKey;
        }
    }
}
export function safeJSONParse(data, silent = true) {
    try {
        return JSON.parse(data);
    }
    catch (error) {
        if (!silent) {
            console.warn('Recovered from failed JSON parsing with error:', error);
        }
        return data;
    }
}
